import type { FormatoDocumento } from '@/shared/types/documentoPreview';

const EXTENSOES_IMAGEM = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
const EXTENSOES_PLANILHA = ['xls', 'xlsx', 'csv'];

export function extensaoDoNome(nome: string): string {
  const partes = nome.split('.');
  return partes.length > 1 ? (partes.pop()?.toLowerCase() ?? '') : '';
}

/**
 * Classifica um documento pelo MIME persistido, caindo para a extensão do nome
 * quando o MIME está ausente ou genérico (documentos gerados pelo sistema).
 *
 * `doc` (Word binário legado) é um formato próprio: não há conversor
 * client-side, então o chamador deve tratá-lo como sem pré-visualização.
 *
 * `imagem` inclui `svg`, que é formato de conteúdo ativo: o chamador tem de
 * renderizar `imagem` em `<img>`, nunca em `<iframe>`/`<object>`, onde o script
 * embutido no SVG executaria com a origem da aplicação.
 */
export function detectarFormato(
  tipoMime: string | null | undefined,
  nome: string,
): FormatoDocumento {
  const mime = tipoMime ?? '';
  const extensao = extensaoDoNome(nome);

  if (mime === 'application/pdf' || extensao === 'pdf') return 'pdf';
  if (mime.startsWith('image/') || EXTENSOES_IMAGEM.includes(extensao)) return 'imagem';
  if (mime.includes('wordprocessingml') || extensao === 'docx') return 'docx';
  if (mime === 'application/msword' || extensao === 'doc') return 'doc';
  if (
    mime.includes('spreadsheetml') ||
    mime.includes('ms-excel') ||
    mime === 'text/csv' ||
    EXTENSOES_PLANILHA.includes(extensao)
  ) {
    return 'planilha';
  }
  return 'sem-preview';
}
